import React, { useEffect, useState } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Badge, Card, Col, Descriptions, Row, Space, Statistic } from 'antd'
import { selectActionEvent, selectPackagesSpecByID } from 'Store/pos/selector'
import { ConfirmDailog, EventModal, LoadingView } from 'Components/modal'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { PrimaryButton } from 'Components/button'
import { PackagesSpecByIDPrice, PackagesSpecByIDReq, PackagesRegisReq } from 'Store/pos/types'
import { packageSpecByIDAPI, buyPackageAPI, renewPackageAPI } from 'Store/pos/api'
import { selectCurrentUser } from 'Store/user/selector'
import { formatDateTime, getDiffDay, getNewEndDate, numberWithComma } from 'helpers/format'
import { clearEventAction } from 'Store/pos/actions'
import { useNavigate, useParams } from 'react-router-dom'

type Props = ReduxProps

const PosRegister: React.FunctionComponent<Props> = props => {
  const { packageSpecByID, currentUser, event } = props
  const [activePrice, setActivePrice] = useState({} as PackagesSpecByIDPrice)
  const [confirmModal, setConfirmModal] = useState(false)
  const dispatch = useDispatch()
  let params = useParams()
  let history = useNavigate()
  const { id: packageID } = params

  const data = packageSpecByID.data
  const isBuy = data?.is_buy === true || data?.is_expire === true
  const canRenew = data?.is_renew === true
  const title = isBuy
    ? 'ลงทะเบียนใช้บริการเครื่องมือช่วยขายหน้าร้าน (Terminal)'
    : 'ต่ออายุการใช้งานเครื่องมือช่วยขายหน้าร้าน (Terminal)'

  const prices = data?.package_properties || []

  const onGetPackageSpecByID = (): void => {
    const req: PackagesSpecByIDReq = {
      id: parseInt(packageID || '') || 0,
    }
    dispatch(packageSpecByIDAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onBuyPackage = (): void => {
    const req: PackagesRegisReq = {
      package_property_id: activePrice.id,
    }
    dispatch(buyPackageAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onRenewPackage = (): void => {
    const req: PackagesRegisReq = {
      package_property_id: activePrice.id,
    }
    dispatch(renewPackageAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetPackageSpecByID()
    }
  }, [packageID])

  useEffect(() => {
    if (data?.package_properties && data?.package_properties.length > 0) {
      setActivePrice(packageSpecByID.data?.package_properties[0] as PackagesSpecByIDPrice)
    }
  }, [data])

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onSuccess = (): void => {
    clearEvent()
    history(`/pos`)
  }

  const onConfirmRegis = (): void => {
    setConfirmModal(false)
    if (isBuy) {
      onBuyPackage()
    } else {
      onRenewPackage()
    }
  }

  const ConfirmRegisterModal = (
    <ConfirmDailog
      title={`ยืนยันการ${isBuy ? 'ซื้อ' : 'ต่ออายุ'} "${data?.name}" `}
      description={`ราคารวมทั้งสิ้น ${numberWithComma(activePrice.price)} บาท / ${activePrice.day} วัน`}
      isShow={confirmModal}
      confirmBtnTxt="ยืนยัน"
      handleOk={onConfirmRegis}
      handleCancel={() => setConfirmModal(false)}
    />
  )

  const valStyle = {
    color: Theme.colors.black,
    fontFamily: Theme.fontFamily.regular,
    fontSize: Theme.typography.h4,
  }

  const remainDay: number = getDiffDay(data?.end_date || '') || 0
  const totalDay = remainDay + activePrice.day

  return (
    <HomePageLayout selected="pos" title={title}>
      <LoadingView isShow={packageSpecByID.event.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onSuccess} errorCalback={clearEvent} />
      {ConfirmRegisterModal}
      <PackageWrapper>
        <Row justify="start" gutter={[16, 16]}>
          <Col lg={24} md={24} xs={24}>
            <PackageWhite>
              <Descriptions title="" bordered>
                <Descriptions.Item label="ชื่อแพ็กเกจ" span={3}>
                  <PackageName>{data?.name || ''}</PackageName>
                </Descriptions.Item>
                <Descriptions.Item label="แนะนำสำหรับ" span={3}>
                  <Text>{data?.description || ''}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="รายละเอียดแพ็กเกจ" span={3}>
                  <Space direction="vertical">
                    {data?.properties.map((item: string, index: number) => {
                      return <TextBadge key={index} color={Theme.colors.drakGrey} text={item} />
                    })}
                  </Space>
                </Descriptions.Item>
                <Descriptions.Item label="จำนวนผู้ใช้งานสูงสุด" span={3}>
                  <Text>{numberWithComma(data?.limit_staff || 0)} คน</Text>
                </Descriptions.Item>
                <Descriptions.Item label="จำนวนเครื่อง Terminal ที่ใช้งานสูงสุด" span={3}>
                  <Text>{numberWithComma(data?.limit_terminal || 0)} เครื่อง</Text>
                </Descriptions.Item>
                <Descriptions.Item label="เลือกวันที่ต้องการซื้อ" span={3}>
                  {prices.map((item, key: number) => {
                    return (
                      <div onClick={() => setActivePrice(item)} key={key}>
                        <CardPrice className={activePrice.id === item.id ? 'actived' : ''}>
                          <Statistic
                            title={`${item.day} วัน`}
                            value={item.price}
                            suffix={<Unit>บาท</Unit>}
                            valueStyle={valStyle}
                            formatter={(val: any) => numberWithComma(val || 0)}
                          />
                        </CardPrice>
                      </div>
                    )
                  })}
                </Descriptions.Item>
                {!isBuy && canRenew && (
                  <Descriptions.Item label="ข้อมูลแพ็กเกจปัจจุบัน" span={3}>
                    <Text>{`เริ่มเปิดใช้งานเมื่อ ${formatDateTime(data?.start_date || '')}`}</Text>
                    <Text>{`หมดอายุในวันที่ ${formatDateTime(data?.end_date || '')}`}</Text>
                    <WarningText>{`เหลือระยะเวลาในการใช้งานแพ็กเกจ ${getDiffDay(data?.end_date || '').toFixed(
                      0,
                    )} วัน`}</WarningText>
                  </Descriptions.Item>
                )}
                {!isBuy && canRenew && (
                  <Descriptions.Item label="จำนวนวันทั้งสิ้น" span={3}>
                    <Price>{totalDay.toFixed(0)} วัน</Price>
                    <WarningText>{`แพ็กเกจจะหมดอายุครั้งถัดไป ${getNewEndDate(
                      data?.end_date || '',
                      activePrice.day,
                    )}`}</WarningText>
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="ชำระทั้งสิ้น" span={3}>
                  <Price>{numberWithComma(activePrice.price, true)} บาท</Price>
                </Descriptions.Item>
              </Descriptions>
            </PackageWhite>
          </Col>
        </Row>
      </PackageWrapper>
      {isBuy || canRenew ? (
        <Row justify="center">
          <Col lg={6} xs={24}>
            <ButtonWrapper>
              <PrimaryButton text={'ชำระเงิน'} onClick={() => setConfirmModal(true)} />
            </ButtonWrapper>
          </Col>
        </Row>
      ) : (
        <Row justify="center" gutter={16}>
          <Col span={24}>
            <ErrorText>
              <br />
              *ไม่สามารถต่ออายุแพ็กเกจได้ เนื่องจากคุณยังไม่ได้ทำการ Activate แพ็กเกจนี้
            </ErrorText>
          </Col>
          <Col lg={6} xs={24}>
            <ButtonWrapper>
              <PrimaryButton
                text={'กลับไปหน้าจัดการแพ็กเกจ'}
                btnType="Cancel"
                onClick={() => {
                  history(`/pos`)
                }}
              />
            </ButtonWrapper>
          </Col>
        </Row>
      )}
    </HomePageLayout>
  )
}

const CardPrice = styled(Card.Grid)`
  width: 25%;
  cursor: pointer;
  text-align: center;
  &.actived {
    background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
    span,
    div {
      color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    }
  }

  @media only screen and (max-width: 720px) {
    width: 100%;
  }
`

const Unit = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
`

const PackageWrapper = styled.div`
  margin-top: 20px;
`

const PackageWhite = styled.div`
  background-color: #fff;
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  text-align: center;
`

const Price = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h4};
  text-align: left;
`

const PackageName = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  text-align: left;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const TextBadge = styled(Badge)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4} !important;
  text-align: left;
  .ant-badge-status-text {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }
`

const Text = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const WarningText = styled(Text)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const ErrorText = styled.div`
  text-align: center;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    packageSpecByID: selectPackagesSpecByID(state),
    event: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PosRegister)
